/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable react/hook-use-state */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useRef, useEffect, useMemo } from "react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-expect-error
import { ExcelRenderer } from "react-excel-renderer";
import { fromExcelDate } from "js-excel-date-convert";
import { Switch } from "@progress/kendo-react-inputs";
import { showToast } from "utils/helper";
import {
  Button,
  Combobox,
  Input,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@repo/ui";
import { TrashIcon } from "lucide-react";
import { useGetCashCenters, useGetCustomers } from "utils/apis/lookups.api";
import {
  useCreateWorkLoad,
  useGetWorkLoadFixedServices,
} from "utils/apis/workload.api";

const serviceTypes = [
  {
    id: "B2B Service",
    text: "B2B Service",
  },
  // {
  //   id: "Collection",
  //   text: "Collection",
  // },
  // {
  //   id: "Delivery",
  //   text: "Delivery",
  // },
  // {
  //   id: "Clearance",
  //   text: "Clearance",
  // },
  // {
  //   id: "Replenishment",
  //   text: "Replenishment",
  // },
  // {
  //   id: "Kiosk Service",
  //   text: "Kiosk Service",
  // },
];

const periodTypes = [
  {
    id: "Day Of Week",
    text: "Day Of Week",
  },
  {
    id: "Date Of Month",
    text: "Date Of Month",
  },
];

const daysOfWeek = [
  {
    id: "Monday",
    text: "Monday",
  },
  {
    id: "Tuesday",
    text: "Tuesday",
  },
  {
    id: "Wednesday",
    text: "Wednesday",
  },
  {
    id: "Thursday",
    text: "Thursday",
  },
  {
    id: "Friday",
    text: "Friday",
  },
  {
    id: "Saturday",
    text: "Saturday",
  },
  {
    id: "Sunday",
    text: "Sunday",
  },
];

function AddFixedServices({ onWorkloadAdded }: any) {
  const currentDate = new Date();
  const [ddlCashCenters, setDdlCashCenters] = useState("");
  const [ddlCustomers, setDdlCustomers] = useState("");
  const [ddlServiceTypes, setDdlServiceTypes] = useState("");
  const [ddlPeriodTypes, setDdlPeriodTypes] = useState("");
  const [ddlDaysOfWeek, setDdlDaysOfWeek] = useState("");
  const [ddlDateOfMonth, setDdlDateOfMonth] = useState("");

  const [services, setServices] = useState<any[]>([]);

  const [btnDisabled, setBtnDisabled] = useState(false);
  const [btnUpdateText, setBtnUpdateText] = useState("Save Workload");

  const { data: cashCenters } = useGetCashCenters();
  const { data: customers } = useGetCustomers();

  const daysInMonth = useMemo(() => {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    return new Date(year, month + 1, 0).getDate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dateOfMonth = useMemo(
    () =>
      Array.from({ length: daysInMonth }, (_, i) => ({
        id: (i + 1).toString(),
        text: (i + 1).toString(),
      })),
    [daysInMonth],
  );

  const { data: fixedServices } = useGetWorkLoadFixedServices({
    cashCenterId: ddlCashCenters,
    customerId: ddlCustomers,
    serviceType: ddlServiceTypes,
    periodType: ddlPeriodTypes,
    dayOfWeek: ddlDaysOfWeek,
    dateOfMonth: ddlDateOfMonth,
  });

  const onDdlPeriodTypesChanged = (value: string) => {
    if (!value) {
      setDdlPeriodTypes("");
    } else {
      setDdlPeriodTypes(value);
      setDdlDaysOfWeek("");
      setDdlDateOfMonth("");
    }
  };

  const fileHandler = (event: any) => {
    const fileObj = event.target.files[0];
    const servicesList: any[] = [];
    ExcelRenderer(fileObj, (err: any, resp: any) => {
      if (err) {
        showToast("error", err);
      } else {
        const rows = resp.rows;

        if (ddlServiceTypes === "B2B Service") {
          for (let index = 1; index < rows.length; index++) {
            const requestNo = parseInt(rows[index][0] || index);
            const sourceBarcode = rows[index][1];
            const onwardBarcode = rows[index][2];
            const invoicingModel = rows[index][3];
            const jobNature = rows[index][4];
            const jobType = rows[index][5];
            const priority = parseInt(rows[index][6]);
            const routeNo = rows[index][7];
            const serviceWindowStart = fromExcelDate(rows[index][8]);
            const serviceWindowEnd = fromExcelDate(rows[index][9]);
            const isActive = rows[index][10];

            if (sourceBarcode && onwardBarcode) {
              const obj: any = {
                deleteId: crypto.randomUUID(),
                requestNo,
                sourceBarcode,
                onwardBarcode,
                invoicingModel,
                jobType,
                jobNature,
                priority,
                routeNo,
                shift: "morning",
                serviceWindowStart,
                serviceWindowEnd,
                isActive,
              };

              servicesList.push(obj);
            }
          }
        } else {
          for (let index = 1; index < rows.length; index++) {
            const sourceBarcode = rows[index][0];
            const onwardBarcode = rows[index][1];
            const invoicingModel = rows[index][2];
            const jobNature = rows[index][3];
            const jobType = rows[index][4];
            const priority = parseInt(rows[index][5]);
            const routeNo = rows[index][6];
            const serviceWindowStart = fromExcelDate(rows[index][7]);
            const serviceWindowEnd = fromExcelDate(rows[index][8]);
            const isActive = rows[index][9];

            if (sourceBarcode && onwardBarcode) {
              const obj: any = {
                deleteId: crypto.randomUUID(),
                requestNo: index,
                sourceBarcode,
                onwardBarcode,
                invoicingModel,
                jobType,
                jobNature,
                priority,
                routeNo,
                shift: "morning",
                serviceWindowStart,
                serviceWindowEnd,
                isActive,
              };

              servicesList.push(obj);
            }
          }
        }

        if (servicesList.length > 0) {
          const locList: any = [];
          servicesList.forEach((sl: any) => {
            locList.push(sl);
          });

          setServices((prev) => [...prev, ...locList]);
          setBtnDisabled(false);
        } else {
          showToast("error", "No data found in excel file.");
        }
      }
    });
  };

  const deleteService = (rowIndex: any) => {
    let updatedServices: any = services?.slice();

    services.map((row: any, index: any) => {
      if (index === rowIndex) {
        updatedServices = updatedServices.filter(
          (cc: any) => cc.deleteId !== row.deleteId,
        );
      }
      return row;
    });

    setServices(updatedServices);

    if (services.length > 0) setBtnDisabled(false);
    else setBtnDisabled(true);
  };

  function ServiceStatusCell({ dataItem }: any) {
    return (
      <td className="text-center mt-3">
        <Switch checked={dataItem.isActive} />
      </td>
    );
  }

  function DeleteButtonCell({ dataIndex }: any) {
    const onClick = () => {
      deleteService(dataIndex);
    };

    return (
      <td className="text-center mt-3">
        <Button
          variant="destructive"
          className="p-3"
          onClick={onClick}
          style={{ width: 40 }}
        >
          <TrashIcon />
        </Button>
      </td>
    );
  }

  const {
    mutate: createWorkLoad,
    isSuccess: createSuccess,
    error,
  } = useCreateWorkLoad();

  const onBtnAddWorkloadClicked = () => {
    if (!ddlCashCenters) {
      showToast("error", "Please select cash center");
      return;
    }

    if (!ddlCustomers) {
      showToast("error", "Please select customer");
      return;
    }

    if (!ddlServiceTypes) {
      showToast("error", "Please select Service type");
      return;
    }

    if (!ddlPeriodTypes) {
      showToast("error", "Please select period type");
      return;
    }

    if (!ddlDaysOfWeek && ddlPeriodTypes === "Day Of Week") {
      showToast("error", "Please select day of week");
      return;
    }

    if (!ddlDateOfMonth && ddlPeriodTypes === "Date Of Month") {
      showToast("error", "Please select date of month");
      return;
    }

    if (services.length === 0) {
      showToast("error", "No Services added.");
      return;
    }

    const workload = services.map((srv: any) => ({
      requestNo: srv.requestNo,
      sourceBarcode: srv.sourceBarcode.toString(),
      onwardBarcode: srv.onwardBarcode.toString(),
      invoicingModel: srv.invoicingModel,
      jobType: srv.jobType,
      shift: srv.shift,
      jobNature: srv.jobNature,
      serviceWindowStart: srv.serviceWindowStart,
      serviceWindowEnd: srv.serviceWindowEnd,
      priority: srv.priority,
      isActive: srv.isActive,
      routeNo: srv.routeNo,
    }));

    const workloadDto = {
      cashCenterId: ddlCashCenters,
      customerId: ddlCustomers,
      serviceType: ddlServiceTypes,
      periodType: ddlPeriodTypes,
      ...(ddlDateOfMonth && ddlPeriodTypes === "Date Of Month"
        ? { dateOfMonth: ddlDateOfMonth }
        : { dayOfWeek: ddlDaysOfWeek }),
      services: workload,
    };

    setBtnDisabled(true);
    setBtnUpdateText("Creating Workload....");
    createWorkLoad(workloadDto);
  };

  useEffect(() => {
    if (fixedServices?.length) {
      setServices(
        fixedServices?.map((i: any) => ({
          ...i,
          deleteId: crypto.randomUUID(),
        })),
      );
    } else {
      setServices([]);
    }
  }, [fixedServices]);

  useEffect(() => {
    if (createSuccess) {
      setBtnDisabled(false);
      setBtnUpdateText("Save Workload");
      setDdlCashCenters("");
      setDdlCustomers("");
      setDdlServiceTypes("");
      setDdlDaysOfWeek("");
      onWorkloadAdded();
    }

    if (error) {
      setBtnDisabled(false);
      setBtnUpdateText("Save Workload");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createSuccess, error]);

  return (
    <>
      <div className="border-b mb-3 bg-accent" />
      <Button
        variant="secondary"
        className="ml-auto flex"
        onClick={onBtnAddWorkloadClicked}
        disabled={btnDisabled}
      >
        {btnUpdateText}
      </Button>
      <div className="border-b my-3 bg-accent" />
      <div className="flex gap-4">
        <div className="flex-1">
          <label className="font-medium leading-none block mb-2">
            Cash Center
            <sup className="text-red-600">*</sup>
          </label>
          <Combobox
            value={ddlCashCenters}
            data={cashCenters?.map((st: any) => ({
              value: st.cashCenterId,
              label: st.name,
            }))}
            placeholder="Select Cash Center"
            setValue={setDdlCashCenters}
          />
        </div>
        <div className="flex-1">
          <label className="font-medium leading-none block mb-2">
            Customer
            <sup className="text-red-600">*</sup>
          </label>
          <Combobox
            value={ddlCustomers}
            data={customers?.map((st: any) => ({
              value: st.customerId,
              label: st.name,
            }))}
            placeholder="Select Customer"
            setValue={setDdlCustomers}
          />
        </div>
      </div>

      <div className="flex gap-4 mt-3">
        <div className="flex-1">
          <label className="font-medium leading-none block mb-2">
            Service Type
            <sup className="text-red-600">*</sup>
          </label>
          <Select onValueChange={setDdlServiceTypes} value={ddlServiceTypes}>
            <SelectTrigger>
              <SelectValue placeholder="Select Service Type" />
            </SelectTrigger>
            <SelectContent>
              {serviceTypes?.map((item) => (
                <SelectItem key={item.id} value={item.id}>
                  {item.text}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="flex-1">
          <label className="font-medium leading-none block mb-2">
            Period Type
            <sup className="text-red-600">*</sup>
          </label>
          <Select
            onValueChange={onDdlPeriodTypesChanged}
            value={ddlPeriodTypes}
          >
            <SelectTrigger>
              <SelectValue placeholder="Select Period Type" />
            </SelectTrigger>
            <SelectContent>
              {periodTypes?.map((item) => (
                <SelectItem key={item.id} value={item.id}>
                  {item.text}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>

      <div className="flex gap-4 mt-3">
        <div className="flex-1">
          <label className="font-medium leading-none block mb-2">
            Day of Week
            <sup className="text-red-600">*</sup>
          </label>
          <Select
            onValueChange={setDdlDaysOfWeek}
            value={ddlDaysOfWeek}
            disabled={ddlPeriodTypes !== "Day Of Week"}
          >
            <SelectTrigger>
              <SelectValue placeholder="Select Day Of Week" />
            </SelectTrigger>
            <SelectContent>
              {daysOfWeek?.map((item) => (
                <SelectItem key={item.id} value={item.id}>
                  {item.text}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div className="flex-1">
          <label className="font-medium leading-none block mb-2">
            Date of Month
            <sup className="text-red-600">*</sup>
          </label>
          <Select
            onValueChange={setDdlDateOfMonth}
            value={ddlDateOfMonth}
            disabled={ddlPeriodTypes !== "Date Of Month"}
          >
            <SelectTrigger>
              <SelectValue placeholder="Select Date Of Month" />
            </SelectTrigger>
            <SelectContent>
              {dateOfMonth?.map((item) => (
                <SelectItem key={item.id} value={item.id}>
                  {item.text}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>

      <div className="border-b my-3 bg-accent" />

      <label className="font-medium leading-none block mb-2">
        Attach Services List
        <sup className="text-red-600">*</sup>
      </label>
      <Input
        className="w-[50%]"
        type="file"
        onChange={fileHandler}
        style={{ padding: "10px" }}
      />

      <div className="border-b my-3 bg-accent" />

      {services.length > 0 && (
        <Grid data={services}>
          {ddlServiceTypes === "B2B Service" ? (
            <GridColumn field="requestNo" title="Req no." width={90} />
          ) : null}
          <GridColumn
            field="sourceBarcode"
            title={
              ddlServiceTypes === "B2B Service"
                ? "Source Barcode"
                : "Cc Barcode"
            }
          />
          <GridColumn field="onwardBarcode" title="Onward Barcode" />
          <GridColumn field="jobType" title="Job Type" width={100} />
          <GridColumn field="jobNature" title="Job Nature" width={120} />
          <GridColumn
            title="Status"
            width={90}
            cell={ServiceStatusCell}
            className="text-center"
          />
          <GridColumn
            width={90}
            title="Remove"
            className="text-center"
            cell={DeleteButtonCell}
          />
        </Grid>
      )}
    </>
  );
}

export default AddFixedServices;
